//region :: Imports ::
import React, {ReactElement} from 'react';
import MComponent from './Toolkit/Components/Component';
import MTopbarButton from './Toolkit/Components/Shell/TopbarButton';
import MShell from './Toolkit/Components/Shell/Shell';
import WithRouterProps from './Toolkit/WithRouterProps';
import withRouter from './Toolkit/WithRouter';
import MAuthenticate from './Toolkit/Components/Auth/Authenticate';
import MAuthorize from './Toolkit/Components/Auth/Authorize';
import EnumClass from './Context/EnumClass';
import {Roles} from './Roles';

//endregion

/** */
type Props = WithRouterProps & {}

/** */
class App extends MComponent<Props> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

    }

    /** */
    private bindMethods(): void {
        this.homeButton_onClick = this.homeButton_onClick.bind(this);

    }

    private homeButton_onClick(): void {
        this.props.navigate('/safedigs');
    }

        /** */
    public render(): ReactElement {

            return (
                <MAuthenticate>
                    <MAuthorize roles={[Roles.Planner, Roles.Safedigs, Roles.Hotjobs, Roles.Noticing]}>
                        <EnumClass>
                            <MShell appTitle={process.env.REACT_APP_NAME!}
                                    topbarButtons={
                                        [
                                            <MTopbarButton label="Safe Digs" icon="pi-users" onClick={this.homeButton_onClick}/>
                                        ]
                                    }/>
                        </EnumClass>
                    </MAuthorize>
                </MAuthenticate>
            );

    }

}

export default withRouter(App);
